import {atom} from 'recoil';

import {IAccountGroup} from '../../shared/types/user-account-groups.types';
import {IUserAccount} from '../../shared/types/user-account.types';
import {IWorkerSelectOption} from '../../api/strategies/searchWorkersStrategy';
import {IPageableDto, IPageableTable} from '../../shared/types/pageable.types';
import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

export type EditGroupModeType = 'REGROUP' | 'DEFAULT';

export const accountGroupsState = atom<IPageableDto<IAccountGroup>>({
  key: 'accountGroupsState',
  default: getEmptyPage<IAccountGroup>(),
});

export const currentAccountGroupState = atom<IAccountGroup | null>({
  key: 'currentAccountGroupState',
  default: null,
});

export const currentAccountGroupIdState = atom<number | null>({
  key: 'currentAccountGroupIdState',
  default: null,
});

export const accountGroupUsersState = atom<IUserAccount[] | null>({
  key: 'accountGroupUsersState',
  default: null,
});

export const accountGroupUsersSelectionState = atom<IWorkerSelectOption<IUserAccount>[] | null>({
  key: 'accountGroupUsersSelectionState',
  default: null,
});

export const accountGroupUsersSelectionToRegroupState = atom<{
  usersToRegroup: number[];
  isLeaderSelected: boolean;
}>({
  key: 'accountGroupUsersSelectionToRegroupState',
  default: {
    usersToRegroup: [],
    isLeaderSelected: false,
  },
});

export const editGroupModeState = atom<EditGroupModeType>({
  key: 'editGroupModeState',
  default: 'DEFAULT',
});

export const accountGroupsQueryTrigger = atom<number>({
  key: 'accountGroupsQueryTrigger',
  default: 0,
});

export const accountGroupControlModeState = atom<'ADD' | 'EDIT'>({
  key: 'accountGroupControlModeState',
  default: 'ADD',
});

export const accountGroupControlState = atom<boolean>({
  key: 'accountGroupControlState',
  default: false,
});

export const accountGroupSortQueryTrigger = atom<{field: string; sort: 'asc' | 'desc' | null | undefined}[]>({
  key: 'accountGroupSortQueryTrigger',
  default: [],
});

export const userGroupPageable = atom<IPageableTable>({
  key: 'userGroupPageable',
  default: {
    page: 0,
    size: localStorage.getItem('groupsPerPage') ? parseInt(localStorage.getItem('groupsPerPage') as string, 10) : 5,
  },
});
